import { cn } from '@/components/ui/cn';
import { CORE_R, MARK_HALF, PETALS, PETAL_D } from './geometry';

/*
  KanameGlyph — знак Kaname линией, как значок меню: шесть лепестков контуром, ядро точкой. Цвет —
  от текста (currentColor), поэтому значок ведёт себя как остальные: приглушён в покое, коралловый
  у выбранного пункта. Полноцветный знак — KanameMark. Ядро — точкой (значок «О Kaname») или пустым
  кольцом, как у знака с ушедшим ядром (заглушка «я» в Avatar: живое коралловое ядро на экране одно).

  Неполный значок — для пустоты (центр без сервисов, «Заклёпка без пластин»): petals — сколько
  лепестков нарисовано (с 6 часов по часовой стрелке), seats — на месте остальных бледные гнёзда тем
  же контуром. Движения нет.
*/

/** Бледное гнездо на месте лепестка, которого нет. */
const SEAT_OPACITY = 0.3;

export function KanameGlyph({
  core = 'dot',
  petals = 6,
  seats = false,
  className,
}: {
  core?: 'dot' | 'ring';
  /** Сколько лепестков нарисовано, 0–6. */
  petals?: number;
  /** На месте недостающих лепестков — бледные гнёзда. */
  seats?: boolean;
  className?: string;
}) {
  const shown = Math.max(0, Math.min(6, Math.round(petals)));
  return (
    <svg
      viewBox={`${-MARK_HALF} ${-MARK_HALF} ${MARK_HALF * 2} ${MARK_HALF * 2}`}
      aria-hidden
      className={cn('block', className)}
    >
      {PETALS.filter((k) => k < shown || seats).map((k) => (
        <path
          key={k}
          d={PETAL_D}
          transform={`rotate(${k * 60})`}
          fill="none"
          stroke="currentColor"
          strokeWidth={1.5}
          strokeOpacity={k < shown ? undefined : SEAT_OPACITY}
          strokeLinejoin="round"
          vectorEffect="non-scaling-stroke"
        />
      ))}
      {core === 'dot' ? (
        <circle r={CORE_R * 1.15} fill="currentColor" />
      ) : (
        <circle
          r={CORE_R * 1.15}
          fill="none"
          stroke="currentColor"
          strokeWidth={1.25}
          vectorEffect="non-scaling-stroke"
        />
      )}
    </svg>
  );
}
